import { makeStyles, fade } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: theme.zIndex.loadingOverlay,
        background: fade('#fff', 0.5)
    }
}));

export default useStyles;